import { mediaMax } from '@/app/styles/breakpoints'
import { theme } from '@/app/styles/theme'
import { Flex, Typography } from 'antd'
import styled from 'styled-components'

export const LogRow = styled(Flex)<{
  type?: 'info' | 'warning' | 'error' | 'access'
}>`
  padding: 10px 8px;
  border-bottom: 1px solid ${(props) => props.theme.colors.divider};
  background: ${(props) => {
    switch (props.type) {
      case 'error':
        return theme.colors.alert.error.bg
      case 'warning':
        return theme.colors.alert.warning.bg
      case 'access':
        return theme.colors.alert.success.bg
      default:
        return 'transparent'
    }
  }};
  gap: 12px;
  ${mediaMax.sm} {
    padding: 8px;
  }
`

export const LogTime = styled(Typography.Text)`
  width: 140px;
  line-height: 20px;
  letter-spacing: -0.15px;
  white-space: nowrap;
  ${mediaMax.sm} {
    width: auto;
    line-height: 18px;
    font-size: 12px;
  }
`

export const LogType = styled.div`
  width: 85px;
  line-height: 20px;
  ${mediaMax.sm} {
    width: auto;
  }
`

export const LogMessage = styled(Typography.Text)`
  flex: 1;
  min-width: 0;
  line-height: 20px;
  ${mediaMax.sm} {
    font-size: 12px;
    line-height: 18px;
  }
`
